/**
 * Extracts product/brand names from bold markdown in recent bot messages.
 * Used by useWebSearch to build search keywords that match AI suggestions.
 */
export function extractBoldKeywords(
  messages: Array<{ sender: string; text?: string }>,
): string[] {
  const keywords: string[] = [];
  const recentBotMessages = messages.filter(m => m.sender === 'bot').slice(-3);
  for (const msg of recentBotMessages) {
    const text = msg.text || '';
    const boldMatches = text.matchAll(/\*\*([^*]{4,80})\*\*/g);
    for (const match of boldMatches) {
      const name = match[1].trim();
      // Skip known label prefixes (Phase, Note, Step, etc.)
      const isLabelPrefix = /^(phase|note|tip|step|warning|important|option)\b/i.test(name);
      // Skip tokens with no Latin or Korean letters (e.g. "5000", "###")
      const hasNoLetters = !/[A-Za-z\u3131-\uD79D]/.test(name);
      if (isLabelPrefix || hasNoLetters) continue;
      if (!keywords.includes(name)) {
        keywords.push(name);
      }
    }
  }
  return keywords;
}
